import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PlanType } from "../../components/enums/plan-type";
import useMsalApi from "../../components/use-msal-api";
import BasicLifeReview from "../review/basic-life-review";
import BeneficiariesReview from "../review/beneficiaries-review";
import DependentsReview from "../review/dependents-review";
import DisabilityReview from "../review/disability-review";
import Employee from "../review/employee";
import FsaReview from "../review/fsa-review";
import HealthReview from "../review/health-review";
import VoluntaryLifeReview from "../review/voluntary-life-review";
import { StructuredListSkeleton, Button } from "carbon-components-react";
import {
  buildBeneficiaries,
  buildDependents,
} from "../../components/contact-builder";
import { useNavigate } from "react-router";

const CurrentElections = () => {
  const [loading, setLoading] = useState(true);
  const [enrollments, setEnrollments] = useState();
  const [totalDeductions, setTotalDeductions] = useState(0);
  const [callApi] = useMsalApi();
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [dependents, setDependents] = useState([]);
  const admin = useSelector(s => s.admin);
  const current = useSelector(s => s.enrollments);

  useEffect(() => {
      getEnrollments();
  }, []);

  const navigate = useNavigate();

  const getEnrollments = async () => {
    setLoading(true);
    const path = admin?.isAdmin ? `Enrollments/CurrentAdmin/${current.employee.id}` : "Enrollments/Current";

    const results = await callApi(path, "GET");
    if (!results.error) {
      console.log(results);
      setBeneficiaries(buildBeneficiaries(results));
      setDependents(buildDependents(results));
      setEnrollments(results);
    } else {
      if(results.error?.code === 409)
          navigate("/AlreadyEnrolled");
  }

    setLoading(false);
  };

  const addDeduction = (val) => {
    setTotalDeductions((count) => count + val);
  };

  return (
    <>
      <div className="font-bold text-3xl mb-6">My Current Elections</div>

      {loading ? (
        <>
          <StructuredListSkeleton />
        </>
      ) : (
        <>
          <Employee
            modified={enrollments?.employee}
            unmodified={enrollments?.employee}
          />
          <DependentsReview
            modifiedArray={dependents}
            unmodifiedArray={dependents}
          />
          <HealthReview
            title="Medical"
            modifiedSelections={enrollments.selections}
            unmodifiedSelections={enrollments.selections}
            planType={PlanType.Medical}
            enrollments={enrollments}
            addDeduction={addDeduction}
          />
          <HealthReview
            title="Dental"
            modifiedSelections={enrollments.selections}
            unmodifiedSelections={enrollments.selections}
            planType={PlanType.Dental}
            enrollments={enrollments}
            addDeduction={addDeduction}
          />
          <HealthReview
            title="Vision"
            modifiedSelections={enrollments.selections}
            unmodifiedSelections={enrollments.selections}
            planType={PlanType.Vision}
            enrollments={enrollments}
            addDeduction={addDeduction}
          />
          <DisabilityReview
            enrollments={enrollments}
            addDeduction={addDeduction}
          />
            <HealthReview
              enrollments={enrollments}
              title="Basic Life"
              modifiedSelections={enrollments.selections}
              unmodifiedSelections={enrollments.selections}
              planType={PlanType.BasicLife}
              addDeduction={addDeduction}
            />
          <VoluntaryLifeReview
            enrollments={enrollments}
            modifiedSelections={enrollments.selections}
            unmodifiedSelections={enrollments.selections}
            addDeduction={addDeduction}
          />
          <BeneficiariesReview
            modifiedArray={beneficiaries}
            unmodifiedArray={beneficiaries}
          />
          <FsaReview
            enrollments={enrollments}
            modifiedSelections={enrollments.selections}
            unmodifiedSelections={enrollments.selections}
            addDeduction={addDeduction}
          />
          <Button
            onClick={() => {
              navigate("/");
            }}
          >
            Back
          </Button>
        </>
      )}
    </>
  );
};

export default CurrentElections;
